import QueryClientProvider from './QueryClientProvider';

export default QueryClientProvider;
